module.exports = __webpack_public_path__ + "assets/img/logo_montes.9ad42001.png";